// extracted by mini-css-extract-plugin
export var mobileMenu = "mobileMenu-module--mobileMenu--2LyhR";
export var inner = "mobileMenu-module--inner--51s7I";
export var lang = "mobileMenu-module--lang--286x2";
export var nav = "mobileMenu-module--nav--3QJel";
export var btn = "mobileMenu-module--btn--DPtND";